import { render, staticRenderFns } from "./monitorBox.vue?vue&type=template&id=8642bfda&scoped=true&"
import script from "./monitorBox.vue?vue&type=script&lang=js&"
export * from "./monitorBox.vue?vue&type=script&lang=js&"
import style0 from "./monitorBox.vue?vue&type=style&index=0&id=8642bfda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8642bfda",
  null
  
)

export default component.exports